import { createServerFn } from "@tanstack/react-start";
import { zoekAdresServer } from "./adres.server";
import { AdresSchema } from "./extern-api-policy";
export type { AdresResultaat } from "./adres.server";

export const zoekAdres = createServerFn({ method: "POST" })
  .inputValidator((input: { postcode: string; huisnummer: string }) => AdresSchema.parse(input))
  .handler(({ data }) => zoekAdresServer(data));
